// MenuBar.jsx — clean redesign (no logo), stable height, smooth black hover/active
import React, { useMemo, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button, Drawer, Dropdown, Avatar } from 'antd';
import { DatabaseOutlined, LogoutOutlined, MenuOutlined, UserOutlined } from '@ant-design/icons';
import styles from './styles/MenuBar.module.css';

const { Header } = Layout;

export default function MenuBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [token] = useState(() => localStorage.getItem('token'));
  const [current, setCurrent] = useState('');
  const [open, setOpen] = useState(false);
  const user = useSelector((s) => s.user);
  const headerRef = useRef(null);

  useEffect(() => {
    const handleWheel = (e) => {
      e.preventDefault();
    };

    const headerEl = headerRef.current;
    if (headerEl) {
      headerEl.addEventListener('wheel', handleWheel, { passive: false });
    }

    return () => {
      if (headerEl) {
        headerEl.removeEventListener('wheel', handleWheel);
      }
    };
  }, []);

  const keyByPath = useMemo(() => ({
    '/memberdata': 'memberdb',
  }), []);

  const items = [
    { key: 'memberdb', label: 'จัดการเลขทะเบียนรถ', icon: <DatabaseOutlined />, path: '/memberdata' },
  ];

  useEffect(() => setCurrent(keyByPath[location.pathname] || ''), [location, keyByPath]);

  const onClick = ({ key }) => {
    setCurrent(key);
    const it = items.find(i => i.key === key);
    if (it) navigate(it.path);
    setOpen(false);
  };

  const logout = () => {
    dispatch({ type: 'LOGOUT', payload: null });
    localStorage.removeItem('token');
    navigate('/login');
    setOpen(false);
  };

  const menuProfile = {
    items: [
      { key: 'profile', icon: <UserOutlined />, label: 'ตั้งค่า', onClick: () => navigate('/profile') },
      { key: 'logout', icon: <LogoutOutlined />, label: 'ออกจากระบบ', onClick: logout },
    ],
  };

  if (!token) return null;

  const displayName = (user?.village || user?.email || '').replace(/ต่อpash/g, '').trim();

  return (
    <>
      <Header ref={headerRef} className={styles.header} role="navigation" aria-label="เมนู">
        <div className={styles.inner}>
          <div className={styles.brandText}>TRACXPERT</div>

          <Menu
            mode="horizontal"
            selectedKeys={[current]}
            onClick={onClick}
            items={items}
            className={styles.menu}
          />

          <div className={styles.right}>
            <Dropdown menu={menuProfile} placement="bottomRight" trigger={['click']}>
              <button className={styles.accountBtn}>
                <Avatar size={30} icon={<UserOutlined />} />
                <span className={styles.accountName}>{displayName}</span>
              </button>
            </Dropdown>

            <Button
              type="text"
              aria-label="เปิดเมนู"
              icon={<MenuOutlined style={{ fontSize: 20 }} />}
              onClick={() => setOpen(true)}
              className={styles.mobileTrigger}
            />
          </div>
        </div>
      </Header>

      <Drawer
        placement="right"
        open={open}
        onClose={() => setOpen(false)}
        width={300}
        className={styles.drawer}
        title={
          <div className={styles.drawerHead}>
            <Avatar icon={<UserOutlined />} />
            <div className={styles.drawerMeta}>
              <div className={styles.drawerName}>{displayName || '-'}</div>
              <div className={styles.drawerEmail}>{user?.email || ''}</div>
            </div>
          </div>
        }
      >
        <Menu
          mode="vertical"
          selectedKeys={[current]}
          onClick={onClick}
          items={items}
          className={styles.drawerMenu}
        />
        <div className={styles.drawerActions}>
          <Button type="text" onClick={() => navigate('/profile')} className={styles.drawerProfile}>โปรไฟล์</Button>
          <Button type="primary" danger icon={<LogoutOutlined />} onClick={logout} block className={styles.drawerLogout}>
            ออกจากระบบ
          </Button>
        </div>
      </Drawer>
    </>
  );
}
